/** Bank statement rule conditions joint type */
export enum BankStatementRuleJointTypeEnum {
  /** Logical "AND" (both conditions must be `true`) */
  AND = 'AND',
  /** Logical "OR" (at least one of conditions must be `true`) */
  OR = 'OR',
}
